"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidationError = void 0;
const http_error_1 = require("./http-error");
class ValidationError extends http_error_1.HttpError {
    constructor(zodError) {
        const errors = zodError.issues.map((error) => ({
            field: error.path.join("."),
            message: error.message,
        }));
        super("Bad Request", 400, "errors/validation", undefined, { errors });
    }
}
exports.ValidationError = ValidationError;
